import { showToast } from 'shared/toast/showToast'
import NotifyMeSuccessToast from './NotifyMeSuccessToast'

export const showNotifyMeSuccessToast = () =>
  showToast({
    render: (isOpen) => <NotifyMeSuccessToast isOpen={isOpen} />,
    timeout: 2000,
  })
